import {} from "../env/index.js";
import {} from "./Value.js";
import { formatValue } from "./formatValue.js";
export function formatValues(env, values) {
    return values.map((value) => formatValue(env, value)).join(", ");
}
//# sourceMappingURL=formatValues.js.map